var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerVestel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 16,
    viewBox: "0 0 75 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.3195 0.155762H68.6052V13.6659H74.3843V15.847H63.3195V0.155762V0.155762Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6238 0.155762H62.1356V2.00699H56.6869V7.23787H61.6422V9.0905H56.6869V13.6659H62.4688V15.847H51.6238V0.155762V0.155762Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9999 0.155762H50.7122V2.17401H46.9691V15.847H41.9074V2.17401H37.9999V0.155762V0.155762Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3647 0.043457H33.0673C33.0673 0.043457 27.9631 0.22451 27.5703 4.91925C27.1776 9.61398 32.4704 9.51714 33.4586 11.5228C34.0881 12.8056 32.5441 13.7852 31.2354 13.7852H27.6909V15.9564H33.6996C33.6996 15.9564 39.9934 15.6196 39.1086 10.2736C38.5415 6.82381 34.6921 7.35995 33.4019 5.04135C32.1116 2.72276 34.3617 2.06732 34.6014 2.06732H37.3349L37.3647 0.043457Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6535 0.155762H26.3326V2.00699H20.718V7.23787H25.6733V9.0905H20.718V13.6659H26.6629V15.847H15.6535V0.155762V0.155762Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3967 0.152832L8.98968 11.1016L5.47346 0.152832H0.0318298L5.61241 15.8413H9.67875L15.119 0.152832H12.3967V0.152832Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerVestel);
export default __webpack_public_path__ + "static/media/customer-vestel.fa0895da8abf87ffd631a662b5b917a8.svg";
export { ForwardRef as ReactComponent };